// Verwendungszweck für die Überweisung: EIN Feld zum Kopieren, das die Rechnungsnummer
// enthält — aber nur einmal.
//
// Vorher wurde stumpf „<Rechnungsnummer> <Verwendungszweck|RE-Nummer>" zusammengesetzt.
// Das doppelte die Nummer in fast jedem Beleg: ohne erkannten Zweck stand dort
// „EKA26540470 RE-EKA26540470", und die erkannten Zwecke enthalten die Nummer meist schon
// selbst („Rechnung 26-0808", „Rechnungs-Nr. 60767, Kunden-Nr. 236470").

/** Für den Vergleich: Groß-/Kleinschreibung, Punkte, Bindestriche und Leerzeichen ignorieren. */
function kern(text: string): string {
  return text.toLowerCase().replace(/[^a-z0-9]/g, '');
}

/**
 * Zahlengruppen ohne führende Nullen: „2026-009" → ['2026','9'], „RE2026-09 …" → ['2026','9',…].
 * In der Praxis schreiben Handwerker ihre eigene Rechnungsnummer im Verwendungszweck gern
 * ohne die führende Null („RE2026-09" für Rechnung 2026-009) — Zeichenvergleich allein
 * hielte das für zwei verschiedene Angaben.
 */
function zahlenGruppen(text: string): string[] {
  return (text.match(/\d+/g) || []).map((g) => g.replace(/^0+(?=\d)/, ''));
}

/**
 * Steckt die Nummer im Zweck? Eine Nummer, die Teil einer LÄNGEREN Ziffernfolge ist
 * („296" in „1296", „9" in „19"), zählt nicht — sonst verschluckt die Anzeige die echte
 * Rechnungsnummer, weil zufällig eine Kundennummer sie enthält.
 */
function kernEnthaelt(zweckKern: string, nummerKern: string): boolean {
  if (!nummerKern) return false;
  for (let i = zweckKern.indexOf(nummerKern); i >= 0; i = zweckKern.indexOf(nummerKern, i + 1)) {
    const davor = zweckKern[i - 1] ?? '';
    const danach = zweckKern[i + nummerKern.length] ?? '';
    if (!/\d/.test(davor) && !/\d/.test(danach)) return true;
  }
  return false;
}

/** Kommen die Zahlengruppen der Nummer als zusammenhängende Folge im Zweck vor? */
function enthaeltNummernfolge(zweck: string[], nummer: string[]): boolean {
  if (nummer.length === 0 || zweck.length < nummer.length) return false;
  for (let start = 0; start <= zweck.length - nummer.length; start++) {
    if (nummer.every((g, i) => zweck[start + i] === g)) return true;
  }
  return false;
}

/**
 * Zeigt den erkannten Verwendungszweck; fehlt er, die Rechnungsnummer. Die Nummer wird nur
 * vorangestellt, wenn der Zweck sie nicht ohnehin schon nennt.
 */
export function verwendungszweckAnzeige(
  rechnungsnummer: string | null | undefined,
  verwendungszweck: string | null | undefined,
): string {
  const nummer = (rechnungsnummer || '').trim();
  const zweck = (verwendungszweck || '').trim();

  if (!zweck) return nummer || '-';
  if (!nummer) return zweck;

  const nummerKern = kern(nummer);
  if (kernEnthaelt(kern(zweck), nummerKern)) return zweck;
  if (enthaeltNummernfolge(zahlenGruppen(zweck), zahlenGruppen(nummer))) return zweck;
  return `${nummer} ${zweck}`;
}
